import { Grid, Column, Title, SubTitle, Paragraph } from '@bidalihq/ui';

import Section from '@/components/section';

const Mission = () => {
  return (
    <Section>
      <Grid columns={[1, 6]}>
        <Column span={[1, 4]} start={[1, 2]}>
          <Title className="text-slate-600">Our Mission</Title>
          <SubTitle className="mt-8 mb-16">We&apos;re creating a safer, more inclusive global financial system where anyone with an internet connection can contribute to global GDP.</SubTitle>
          <Paragraph className="mb-8">At Bidali we&apos;re re-imagining commerce and believe that blockchain technology has the potential to change the way we do business.</Paragraph>
          <Paragraph>Using next generation payment rails we are building a platform that enables anyone in the world to send and receive money as easily as sending a photo and keep more of their money while preserving their privacy, while at the same time enabling businesses to grow their customer base and offer unique next-generation incentive programs all over the globe.</Paragraph>
        </Column>
      </Grid>
    </Section>
  );
};

export default Mission;
